import React from 'react';
import { useTheme } from '@emotion/react';
import { ReactComponent as EmptyStateLight } from 'assets/images/illustrations/empty-state-iso.light.svg';
import { ReactComponent as EmptyStateDark } from 'assets/images/illustrations/empty-state-iso.dark.svg';
import { ReactComponent as SomethingWentWrongLight } from 'assets/images/illustrations/something-went-wrong-iso.light.svg';
import { ReactComponent as SomethingWentWrongDark } from 'assets/images/illustrations/something-went-wrong-iso.dark.svg';

export const illustrationNames = ['empty-state', 'something-went-wrong'] as const;
export type IllustrationName = (typeof illustrationNames)[number];

// Figma draws separate light and dark artwork rather than recolouring one, so this is a file swap.
// Keyed off the colour mode, not `isNewDesign`: only new-design surfaces render it at all.
const ARTWORK: Record<
  IllustrationName,
  Record<'light' | 'dark', React.FunctionComponent<React.SVGProps<SVGSVGElement>>>
> = {
  'empty-state': { light: EmptyStateLight, dark: EmptyStateDark },
  'something-went-wrong': { light: SomethingWentWrongLight, dark: SomethingWentWrongDark }
};

type IllustrationProps = {
  name: IllustrationName;
  className?: string;
  'data-e2e'?: string;
};

export const Illustration: React.FunctionComponent<IllustrationProps> = ({ name, className, 'data-e2e': dataE2e }) => {
  const { mode } = useTheme();
  const artworkMode = mode === 'dark' ? 'dark' : 'light';
  const Artwork = ARTWORK[name][artworkMode];

  return <Artwork className={className} data-e2e={dataE2e} data-illustration={`${name}-${artworkMode}`} />;
};

export default Illustration;
